// Revisión manual contra Zentral de tiendas y usuarios en `retail-org-business` («Actualizar»).
import type { GetOrgReconciliationResponse } from '@fiado/type-kit/bin/retailIntegration/dtos/GetReconciliationResponses';
import type {
    StartOrgReconciliationRequest,
    StartOrgReconciliationResponse,
} from '@fiado/type-kit/bin/retailIntegration/dtos/StartOrgReconciliationRequest';
import { apiFetch } from '../../client';

const BASE_URL = import.meta.env.VITE_API_RETAIL_ORG_BASE_URL;

export type { GetOrgReconciliationResponse };

/** `backofficeStartOrgReconciliation` — 202 con el runId; `dryRun` solo calcula la vista previa. */
export function startOrgReconciliation(
    retailerId: string,
    entity: StartOrgReconciliationRequest['entity'],
    dryRun = false,
): Promise<StartOrgReconciliationResponse> {
    const body: Pick<StartOrgReconciliationRequest, 'entity' | 'dryRun'> = dryRun
        ? { entity, dryRun }
        : { entity };
    return apiFetch<StartOrgReconciliationResponse>(
        `/backoffice/retailers/${retailerId}/reconciliations`,
        { method: 'POST', body: JSON.stringify(body), baseUrl: BASE_URL },
    );
}

/** `backofficeGetOrgReconciliation` — estado, páginas y conteos de la corrida. */
export function getOrgReconciliation(
    retailerId: string,
    runId: string,
): Promise<GetOrgReconciliationResponse> {
    return apiFetch<GetOrgReconciliationResponse>(
        `/backoffice/retailers/${retailerId}/reconciliations/${runId}`,
        { baseUrl: BASE_URL },
    );
}
